// extracted by mini-css-extract-plugin
export default {"Title":"UsersSection_Title__axlhi","FirstSection":"UsersSection_FirstSection__zKosW","SecondSection":"UsersSection_SecondSection__CIcsr"};